export default __webpack_public_path__ + "static/media/Chhattisgarhi_af_2.774aebd7.mp3";